// extracted by mini-css-extract-plugin
export default {"button":"_2h00S","commentButton":"_3d4XY","commentButtonIcon":"CPoYZ","commentButtonContent":"_1N7Jd","followButton":"rfFAS","followButtonContent":"_2pD6F","container":"_1IL8w"};